import React from "react";

const Sorting = ({ name, values, onChange, className }) => {
  const handleChange = (e) => {
    const selectedValue = e.target.value;
    onChange(selectedValue);
  };

  return (
    <div>
      <div
        className={` relative flex items-center rounded-lg border border-gray-300 bg-white dark:bg-boxdark transition-colors duration-300 p-1`}
      >
        <select
          className={`${className} flex-1 bg-transparent border-none outline-none text-gray-800 dark:text-gray-200 placeholder-gray-400  dark:placeholder-gray-500 px-2 bg-white dark:bg-boxdark transition-colors duration-300`}
          onChange={handleChange}
          defaultValue=''
        >
          <option value='' disabled>
            {name}
          </option>
          {values?.map((value, index) => (
            <option
              key={index}
              value={
                typeof value.sort === "object"
                  ? JSON.stringify(value.sort)
                  : value.value
              }
            >
              {value.label}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default Sorting;
